import React from 'react';
import { useTheme } from '../../../context/ThemeContext';
import CustomCard from '../../Scanners/components/CustomCard';

/**
 * Skeleton loader for Indicators Table
 */
const IndicatorsTableSkeleton = () => {
  const { theme } = useTheme();

  return (
    <CustomCard>
      <div className="overflow-x-auto -mx-4">
        <table className="w-full">
          <thead>
            <tr
              className={`border-b ${theme === 'dark' ? 'border-[#1F1F1F]' : 'border-[#EBEBEB]'
                }`}
            >
              <th className={`w-1/4 pl-6 pr-3 py-2 text-left text-sm font-medium text-n500`}>
                Type
              </th>
              <th className={`w-1/4 px-3 py-2 text-right text-sm font-medium text-n500`}>
                Current Price
              </th>
              <th className={`w-1/4 px-3 py-2 text-right text-sm font-medium text-n500`}>
                Computed Value
              </th>
              <th className={`w-1/4 pl-3 pr-6 py-2 text-right text-sm font-medium text-n500`}>
                Level
              </th>
            </tr>
          </thead>
          <tbody>
            {[...Array(5)].map((_, index) => (
              <tr
                key={index}
                className={`border-b ${theme === 'dark' ? 'border-[#1F1F1F]' : 'border-[#EBEBEB]'
                  }`}
              >
                {/* Type */}
                <td className="w-1/4 pl-6 pr-3 py-3">
                  <div className="h-4 w-20 bg-n200 rounded animate-pulse mb-2"></div>
                  <div className="h-3 w-32 bg-n200 rounded animate-pulse"></div>
                </td>

                {/* Current Price */}
                <td className="w-1/4 px-3 py-3 text-right">
                  <div className="h-4 w-16 bg-n200 rounded animate-pulse ml-auto"></div>
                </td>

                {/* Computed Value */}
                <td className="w-1/4 px-3 py-3 text-right">
                  <div className="h-4 w-20 bg-n200 rounded animate-pulse ml-auto"></div>
                </td>

                {/* Level */}
                <td className="w-1/4 pl-3 pr-6 py-3 text-right">
                  <div className="h-4 w-16 bg-n200 rounded animate-pulse ml-auto"></div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </CustomCard>
  );
};

export default IndicatorsTableSkeleton;
